module.exports = __webpack_public_path__ + "static/media/twitter.87dfb9b3.png";